module.exports = __webpack_public_path__ + "img/9788952770158.f3305c66.jpg";